export function isNotEmpty(count) {
    return count >= 1;
}
export function isNotFirstInstance(index) {
    return index !== 0;
}
export function normalizeKey(title) {
    return title
        .replace(/-/g, ' ')
        .split(' ')
        .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
        .join(' ')
        .replace(/\s/g, '');
}
